<template>
  <v-btn
    icon small color="primary"
    :title="title"
    @click="click"
  >
    <v-icon class="uikit-icon size-20" :class="icon" />
  </v-btn>
</template>

<script>
export default {
  name: 'ButtonIconSmall',

  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },

  methods: {
    click() {
      this.$emit('click')
    },
  },
}
</script>
